import { IComponentOptions } from "angular";
import { ChangeJournalViewComponentItemController } from "../../../../../records/changeJournal/changeJournalViewComponent/itemObjectDetail/componentController";

export const vsComponentName = "changeJournalMachineConfigurationTypeItemView";
export const changeJournalMachineConfigurationTypeItemViewComponentOptions: IComponentOptions =
  {
    template: require("!html-loader!./index.html").default,
    controller: ChangeJournalViewComponentItemController,
    controllerAs: "itemController",
    bindings: {
      logItem: "<",
    },
  };
